/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductPrice from '../ProductPrice';
import ShoppingCartButton from './ShoppingCartButton';

/** A buy button for the product in an external online shop. */
export default function ProductShopExternalButton({ product, ...rest }) {
  const onlineShop = product?.onlineShop;
  const producerOnlineShop = product?.producer?.onlineShop;
  if (!onlineShop && !producerOnlineShop) return null;
  return (
    <ShoppingCartButton
      href={onlineShop | producerOnlineShop}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {product.onlineShop ? (
        <Trans>Buy online</Trans>
      ) : (
        <Trans>Go to online shop</Trans>
      )}{' '}
      <ProductPrice product={product} sx={{ paddingLeft: 2, opacity: 0.8 }} />
    </ShoppingCartButton>
  );
}

export const fragment = graphql`
  fragment bb_ProductShopExternalButton on Bottlebooks_Product {
    onlineShop
    producer {
      onlineShop
    }
  }

  fragment ProductShopExternalButton on Product {
    ...ProductPrice
  }
`;

ProductShopExternalButton.fragment = gql`
  fragment ProductShopExternalButton on Product {
    onlineShop
    producer {
      onlineShop
    }
    ...ProductPrice
  }
  ${ProductPrice.fragment}
`;
